import makeApiRequest from '../utils/makeApiRequest';
import actionTypes from './types';
import actionFactory from './actionsFactory/types';

const {
  FETCH_DEPTH_DATA,
  FETCH_TRADES_DATA,
  FETCH_DEPTH_DATA_ERROR,
  FETCH_TRADES_DATA_ERROR,
  SET_PRODUCTS,
  SET_EXCHANGE_INFO,
  SET_DEPTH_DATA,
  SET_TRADES_DATA,
  SET_USER_TRADES_DATA_PERIOD,
  SET_TRADE_ORDERS_PERIOD,
  SET_META_DATA,
  SET_LOCALE_DATA,
  SET_NEWS_DATA,
  SET_NATIVE_CURRENCY_DATA,
  SET_TO_FIAT_RATE,
  SET_MARKETS_DATA,
  CLEAR_DEPTH_DATA,
  CLEAR_TRADES_DATA,
  IS_DATA_LOADING,
  CHANGE_CHART_INDICATOR,
  FETCH_ASSET_PIC,
} = actionTypes;

const { SET_IS_MARGIN_PAIR } = actionFactory;

// const FETCH_RETRY_AFTER = 10000;

const DEPTH_API_PATH = '/api/v1/depth?limit=500&symbol=';
const TRADES_API_PATH = '/api/v1/aggTrades?limit=80&symbol=';

export const setProducts = data => dispatch => dispatch({ type: SET_PRODUCTS, data });

export const setExchangeInfo = data => dispatch => dispatch({ type: SET_EXCHANGE_INFO, data });

export const setDepthData = (symbol, data) => dispatch => dispatch({
  type: SET_DEPTH_DATA,
  symbol,
  data,
});

export const setTradesData = (symbol, data) => dispatch => dispatch({
  type: SET_TRADES_DATA,
  symbol,
  data,
});

export const setUserTradesDataPeriod = data => dispatch => dispatch({
  type: SET_USER_TRADES_DATA_PERIOD,
  data,
});

export const setTradeOrdersPeriod = data => dispatch => dispatch({
  type: SET_TRADE_ORDERS_PERIOD,
  data,
});

export const fetchDepthData = symbol => async dispatch => {
  dispatch({ type: FETCH_DEPTH_DATA, symbol });
  try {
    const depth = await makeApiRequest(DEPTH_API_PATH + symbol);
    dispatch(setDepthData(symbol, depth));
  } catch (error) {
    dispatch({ type: FETCH_DEPTH_DATA_ERROR, error });

    // try again
    // setTimeout(() => {
    //   dispatch(fetchDepthData(symbol));
    // }, FETCH_RETRY_AFTER);
  }
};

export const fetchTradesData = symbol => async dispatch => {
  dispatch({ type: FETCH_TRADES_DATA, symbol });
  try {
    const trades = await makeApiRequest(TRADES_API_PATH + symbol);
    dispatch(setTradesData(symbol, trades));
  } catch (error) {
    dispatch({ type: FETCH_TRADES_DATA_ERROR, error });
    throw new Error('fetch trades Data wrong');
    // try again
    // setTimeout(() => {
    //   dispatch(fetchTradesData(symbol));
    // }, FETCH_RETRY_AFTER);
  }
};

export const setAssetPic = data => dispatch => dispatch({ type: FETCH_ASSET_PIC, data });

export const setToFiatRate = data => dispatch => dispatch({ type: SET_TO_FIAT_RATE, data });

export const setMarketsData = data => dispatch => dispatch({ type: SET_MARKETS_DATA, data });

export const setMetaData = data => dispatch => dispatch({
  type: SET_META_DATA,
  data: Object.freeze(data),
});

export const setModuleLocaleData = (module, locale, data) => dispatch => dispatch({
  type: SET_LOCALE_DATA,
  module,
  locale,
  data: Object.freeze(data),
});

export const setLocaleData = (locale, data) => dispatch => dispatch({
  type: SET_LOCALE_DATA,
  locale,
  data: Object.freeze(data),
});

export const setNewsData = (locale, data) => dispatch => dispatch({
  type: SET_NEWS_DATA,
  locale,
  data,
});

export const setIsMarginPair = data => dispatch => dispatch({
  type: SET_IS_MARGIN_PAIR,
  data,
});

export const clearDepthData = symbol => dispatch => dispatch({ type: CLEAR_DEPTH_DATA, symbol });

export const clearTradesData = symbol => dispatch => dispatch({ type: CLEAR_TRADES_DATA, symbol });

export const setDataIsLoading = data => dispatch => dispatch({ type: IS_DATA_LOADING, ...data });

export const setChartIndicator = curInd => dispatch => dispatch({
  type: CHANGE_CHART_INDICATOR,
  curInd,
});

export const setNativeCurrency = data => dispatch => dispatch({
  type: SET_NATIVE_CURRENCY_DATA,
  data,
});
